export enum ContractObligationVersions {
  V1 = 'V1',
}

export enum LicenseAgreementVersions {
  V0 = 'V0',
  V1 = 'V1',
}
